module.exports = __webpack_public_path__ + "img/mergerAndAcquisitionPic.410046b4.png";